import Lookup from 'src/componentes/select2';

const PlanoContingenciaLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/PlanoContingenciaLookup" clearable {...rest} />;

export default PlanoContingenciaLookup;